var exports = {
  "kL": "x7be19a29--29f969--container",
  "YB": "x7be19a29--29f969--columns",
  "kb": "x7be19a29--29f969--left",
  "pG": "x7be19a29--29f969--right",
};

module.exports = exports;
